import {InstallationEquipment} from "../../../models/operations/InstallationEquipment";
import {ProcessStep} from "../../../models/ProcessStep";
import {EEquipmentType} from "../../../models/utils/EEquipmentType";
import EquipmentService from "../../EquipmentService";
import SelectEquipmentTypeStep from "../../../components/steps/select/SelectEquipmentTypeStep";
import {AElement} from "../../../models/elements/AElement";
import {ISpecifications} from "../../../models/utils/ISpecifications";
import StepsAccordingToSpecificationsService from "../StepsAccordingToSpecificationsService";

/**
 *
 * @author Alizée Grand
 * @version 1.0
 * @creation 16/05/2022
 * @last_update 16/05/2022
 **/
class EquipmentInstallationSteps {

    public getEquipmentInstallationSteps(operationData: InstallationEquipment, setOperation: (operation: InstallationEquipment) => void): ProcessStep[] {
        let steps: ProcessStep[] = [];
        steps.push(this.getSelectEquipmentTypeStep(operationData, setOperation));
        const specifications = operationData.equipment?.specifications;
        if(specifications) {
            for (let i = 0; i < specifications.length; i++) {
                steps = steps.concat(this.getElementIdentificationStep( operationData, specifications[i], setOperation));
            }
        }
        return steps;
    }

    private getElementIdentificationStep(installation: InstallationEquipment, specification: ISpecifications, setOperation: (operation: InstallationEquipment) => void): ProcessStep[] {
        const steps: ProcessStep[] = [];
        const elements = installation.equipment?.elements.filter(element => element.type === specification.type);
        const setElement = (element: AElement) => {
            installation.equipment?.elements.push(element);
            setOperation(installation);
        };
        if(elements) {
            if (elements.length !== 0 && elements.length > specification.quantity) {
                throw new Error('Error in specification');
            }
            for (let i = 0; i < specification.quantity; i++) {
                steps.push(StepsAccordingToSpecificationsService.getIdentificationStep(specification.type, setElement, elements[i]));
            }
        }
        return steps;
    }

    // Select equipment type

    private getSelectEquipmentTypeStep(operation: InstallationEquipment, setOperation: (operation: InstallationEquipment) => void) {
        const setEquipmentType = (equipmentType: EEquipmentType) => {
            if(operation.equipment === undefined || operation.equipment.type !== equipmentType) {
                operation.equipment = EquipmentService.createsEquipmentAccordingToType(equipmentType);
                setOperation(operation);
            }
        };
        return new ProcessStep("steps.titles.select-equipment", this.getSelectEquipmentTypeComponent(setEquipmentType, operation.equipment?.type));
    }

    private getSelectEquipmentTypeComponent(setEquipmentType: (equipmentType: EEquipmentType) => void, equipmentType?: EEquipmentType) {
        return <SelectEquipmentTypeStep onValidate={setEquipmentType} initialEquipmentType={equipmentType}/>
    }


}

export default new EquipmentInstallationSteps();
